export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";